/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_ControlInputs */

const en_mk_nav_control = /** @type {(inputs: Mk_Nav_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project control`)
};

const id_mk_nav_control = /** @type {(inputs: Mk_Nav_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendali proyek`)
};

/**
* | output |
* | --- |
* | "Project control" |
*
* @param {Mk_Nav_ControlInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_control = /** @type {((inputs?: Mk_Nav_ControlInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_ControlInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_control(inputs)
	return en_mk_nav_control(inputs)
});